import { Controller } from '@hotwired/stimulus';

// ラジオボタンの変更を検知してフォームを即時送信するコントローラー
export default class extends Controller {
  // ラジオボタンが変更されたらフォームを送信する
  submit() {
    this.element.requestSubmit();
  }
}
